import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { toast } from "sonner"
import { StatsCards } from "./components/stats-cards"
import { TrendCharts } from "./components/trend-charts"
import { LiveFeed } from "./components/live-feed"
import { OutboundLiveFeed } from "./components/outbound-live-feed"
import { RecentFailures } from "./components/recent-failures"

function formatDate() {
  return new Date().toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  })
}

export function DashboardPage() {
  const [params, setParams] = useSearchParams()
  useEffect(() => {
    if (params.get("upgraded") === "1") {
      toast.success("Plan updated. Welcome aboard.")
      params.delete("upgraded")
      params.delete("customer_session_token")
      setParams(params, { replace: true })
    }
  }, [params, setParams])

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between pb-6">
        <h1 className="text-3xl font-bold tracking-tight">Welcome back</h1>
        <span className="text-sm text-muted-foreground">{formatDate()}</span>
      </div>
      <StatsCards />
      <TrendCharts />
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        <div className="lg:col-span-3">
          <LiveFeed />
        </div>
        <div className="lg:col-span-2">
          <RecentFailures />
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        <div className="lg:col-span-3">
          <OutboundLiveFeed />
        </div>
      </div>
    </div>
  )
}
